export const URL = '/v2/pms/accomodations/:placeId/rooms/:roomId/'

export type Req = void

export type Resp = any